import { Container, ContentContainer, Overlay, LoaderContainer, StyledLoader } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Typography } from '../../foundation/Typography/styled.js';

var sizes = {
  small: 12,
  medium: 18
};
function LoaderOverlay(props) {
  var children = props.children,
    _props$enabled = props.enabled,
    enabled = _props$enabled === void 0 ? true : _props$enabled,
    _props$transparent = props.transparent,
    transparent = _props$transparent === void 0 ? false : _props$transparent,
    _props$width = props.width,
    width = _props$width === void 0 ? '100%' : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? '100%' : _props$height,
    _props$loaderSize = props.loaderSize,
    loaderSize = _props$loaderSize === void 0 ? 'medium' : _props$loaderSize,
    _props$position = props.position,
    position = _props$position === void 0 ? 'center' : _props$position,
    label = props.label;
  return /*#__PURE__*/jsxs(Container, {
    $enabled: enabled,
    $width: width,
    $height: height,
    children: [/*#__PURE__*/jsx(ContentContainer, {
      $transparent: transparent,
      $enabled: enabled,
      children: children
    }), /*#__PURE__*/jsx(Overlay, {
      $enabled: enabled,
      $transparent: transparent
    }), /*#__PURE__*/jsxs(LoaderContainer, {
      $enabled: enabled,
      $position: position,
      children: [/*#__PURE__*/jsx(StyledLoader, {
        size: sizes[loaderSize],
        $position: position
      }), label && /*#__PURE__*/jsx(Typography, {
        $fontSize: loaderSize,
        $fontWeight: "medium",
        $appearance: "100",
        children: label
      })]
    })]
  });
}

export { LoaderOverlay };
